<div class="ipm-switches-container" [ngClass]="{'three-options': isThreeOptions}" *ngIf="textArray">
    <ng-container *ngFor="let textList of textArray">
        <input type="radio" id="switch-{{groupName}}-{{textList.key}}" name="{{groupName}}" value="{{textList.key}}" [checked]="textList.key === selectedValue" (input)="onChangeToggle($event)"/>
        <label for="switch-{{groupName}}-{{textList.key}}">{{textList.value}}</label>
    </ng-container>
    <div class="switch-wrapper">
      <div class="switch">
        <ng-container *ngFor="let textList of textArray">
            <div>{{textList.value}}</div>
        </ng-container>
      </div>
    </div>
  </div>